module.exports = "<div class=\"pages-wrap\">\r\n  <pages-top></pages-top>\r\n  <div class=\"pages-body\">\r\n    <sidebar></sidebar>\r\n    <div class=\"pages-content\"><router-outlet></router-outlet></div>\r\n    <right-config></right-config>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pages.component.html
// module id = ./src/app/pages/pages.component.html
// module chunks = main